import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTSData } from "../../../common/components/general/TSDataContext";
import TSGrid from "../../../common/components/ui/TSGrid";
import { MESSAGING_MODE } from "../../../common/constants/generalConstants";
import { MESSAGING_PAGE_ROUTE } from "../../../common/constants/routerConstants";

const SujetSection = () => {
  const { setMode: setModeApp, setMessageActuel, isMobile } = useTSData();
  const navigate = useNavigate();
  const sujets = {
    importation: {
      id: "importation",
      title: "Importation",
      sujets: [
        {
          id: "importation-1",
          title: "Importation de produits",
          description:
            "Comment préparer l’importation et la gestion du titre d’importation ?",
          date: "2023-01-01",
          image: "/assets/cartImportation01.png",
        },
        {
          id: "importation-2",
          title: "Importation de produits",
          description:
            "Quelles sont les principales réglementations encadrant les importations au Maroc ?",
          date: "2023-01-01",
          image: "/assets/cartImportation02.png",
        },
      ],
    },
    exportation: {
      id: "exportation",
      title: "Exportation",
      sujets: [
        {
          id: "exportation-1",
          title: "Exportation de produits",
          description:
            "Quelle est la procédure d'exportation des produits de l'Artisanat?",
          date: "2023-01-01",
          image: "/assets/cartExportationArtisanat.jpeg",
        },
        {
          id: "exportation-2",
          title: "Exportation de produits",
          description:
            "Comment peut-on procéder lors  du contrôle non douanier à l’export ?",
          date: "2023-01-01",
          image: "/assets/cartExportation01.png",
        },
        {
          id: "exportation-3",
          title: "Exportation de produits",
          description:
            "Quelle est la procédure à suivre pour obtenir la licence d’exportation d’un produit soumis à autorisation ?",
          date: "2023-01-01",
          image: "/assets/cartExportation02.png",
        }
      ],
    },
    accordCommerce: {
      id: "accord-commerce",
      title: "Accords commerciaux",
      sujets: [
        {
          id: "accord-commerce-1",
          title: "Accords commerciaux",
          description:
            "Quels sont les avantages préférentiels accordés aux marchandises dans le cadre des accords conclus par le Maroc?",
          mainQuestion: "Quels sont les avantages préférentiels accordés aux marchandises dans le cadre des accords conclus par le Maroc?",
          date: "2023-01-01",
          image: "/assets/cartAccordCom01.png",
        },
      ],
    },
  };
  return (
    <Paper
      sx={{
        p: 2,
        backgroundColor: "#F7F7F7",
        borderRadius: "43px",
        mt: isMobile ? "10px" : "13px",
      }}
    >
      <TSGrid container spacing={isMobile ? 0 : 2} sx={{ mt: isMobile ? 0 : 2, mb: 5 }}>
        <TSGrid item xs={12}>
          <Typography
            variant="tsh4"
            color={"#1A2149"}
            sx={{
              ...(isMobile && { fontSize: "20px", lineHeight: "44.02px" }),
            }}
          >
            Sujets à la une
          </Typography>
        </TSGrid>
        <TSGrid item xs={12}>
          <TSGrid container spacing={2}>
            {Object.keys(sujets).map((sujet) => (
              <TSGrid item xs={12} key={sujet}>
                <TSGrid container spacing={2}>
                  <TSGrid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        height: "100px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="tsb2"
                        color={"#575757"}
                        sx={{
                          ...(isMobile && {
                            fontSize: "20px",
                            lineHeight: "44.02px",
                          }),
                        }}
                      >
                        {sujets[sujet].title}
                      </Typography>
                    </Box>
                  </TSGrid>
                  <TSGrid item xs={12}>
                    <TSGrid container spacing={1} sx={{ marginLeft: "5px" }}>
                      {sujets[sujet].sujets.map((sujet) => (
                        <TSGrid item xs={12} sm={6} md={6} key={sujet.id}>
                          <Tooltip title={sujet.description}>
                            <Card
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "#EEEEEE",
                                width: "95%",
                                height: isMobile ? 100 : 211,
                                cursor: "pointer",
                                transition: "transform 0.2s, box-shadow 0.2s",
                                "&:hover": {
                                  transform: "scale(1.02)",
                                  boxShadow: 6,
                                  backgroundColor: "#f5f5f5",
                                },
                              }}
                              onClick={() => {
                                setMessageActuel(
                                  sujet.mainQuestion || sujet.description
                                );
                                setModeApp(MESSAGING_MODE);
                                navigate(MESSAGING_PAGE_ROUTE);
                              }}
                            >
                              <CardMedia
                                component="img"
                                sx={{
                                  width: isMobile ? 100 : 211,
                                  aspectRatio: "1",
                                  borderRadius: "10px",
                                  objectFit: "cover",
                                }}
                                image={sujet.image}
                                alt="Live from space album cover"
                              />
                              <Box sx={{ flex: 1, padding: 2 }}>
                                <CardContent>
                                  <Typography
                                    variant="tsb4"
                                    component="div"
                                    color="#1A2149"
                                    sx={{
                                      display: "-webkit-box",
                                      WebkitBoxOrient: "vertical",
                                      overflow: "hidden",
                                      WebkitLineClamp: 4,
                                      textOverflow: "ellipsis",
                                      ...(isMobile && {
                                        fontSize: "15px",
                                        lineHeight: "21px",
                                      }),
                                    }}
                                  >
                                    {sujet.description}
                                  </Typography>
                                </CardContent>
                              </Box>
                            </Card>
                          </Tooltip>
                        </TSGrid>
                      ))}
                    </TSGrid>
                  </TSGrid>
                </TSGrid>
              </TSGrid>
            ))}
          </TSGrid>
        </TSGrid>
      </TSGrid>
    </Paper>
  );
};

export default SujetSection;
